class VariantScrollManager {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupScrollListeners());
    } else {
      this.setupScrollListeners();
    }
  }

  setupScrollListeners() {
    const scrollContainers = document.querySelectorAll('.maje-variant-swatch__scroll-container');
    
    scrollContainers.forEach(container => {
      const wrapper = container.querySelector('.maje-variant-swatch__wrapper');
      const leftArrow = container.querySelector('.maje-variant-scroll-arrow--left');
      const rightArrow = container.querySelector('.maje-variant-scroll-arrow--right');
      
      if (!wrapper || !leftArrow || !rightArrow) return;

      // Set initial arrow states
      this.updateArrowStates(wrapper, leftArrow, rightArrow);

      // Add scroll event listener to update arrow states
      wrapper.addEventListener('scroll', () => {
        this.updateArrowStates(wrapper, leftArrow, rightArrow);
      });

      // Add click handlers for arrows
      leftArrow.addEventListener('click', (e) => {
        e.preventDefault();
        this.scrollLeft(wrapper);
      });

      rightArrow.addEventListener('click', (e) => {
        e.preventDefault();
        this.scrollRight(wrapper);
      });

      // Handle resize to update arrow states
      window.addEventListener('resize', () => {
        this.updateArrowStates(wrapper, leftArrow, rightArrow);
      });
    });
  }

  scrollLeft(wrapper) {
    const scrollAmount = wrapper.clientWidth * 0.7; // Scroll 70% of visible width
    wrapper.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  }

  scrollRight(wrapper) {
    const scrollAmount = wrapper.clientWidth * 0.7; // Scroll 70% of visible width
    wrapper.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  }

  updateArrowStates(wrapper, leftArrow, rightArrow) {
    const { scrollLeft, scrollWidth, clientWidth } = wrapper;
    const maxScrollLeft = scrollWidth - clientWidth;

    // Update left arrow
    leftArrow.disabled = scrollLeft <= 0;
    leftArrow.style.opacity = scrollLeft <= 0 ? '0.5' : '1';

    // Update right arrow  
    rightArrow.disabled = scrollLeft >= maxScrollLeft - 1; // -1 for rounding errors
    rightArrow.style.opacity = scrollLeft >= maxScrollLeft - 1 ? '0.5' : '1';

    // Hide arrows if content doesn't overflow
    const shouldShowArrows = scrollWidth > clientWidth;
    leftArrow.style.display = shouldShowArrows ? 'flex' : 'none';
    rightArrow.style.display = shouldShowArrows ? 'flex' : 'none';
  }
}

// Initialize the variant scroll manager
new VariantScrollManager();